module.exports = __webpack_public_path__ + "static/media/blacksheep.b2612104.png";